<template>
  <div class="dial-table-container flex-column">
    <div class="row-1 flex-row">
      <div class="left-table" v-if="dialInfo.groups">
        <div class="left-table-container">
          <div v-for="(row, rowIndex) in dialInfo.groups" :key="`row-${rowIndex}`">
            <div v-if="row.label" class="row">
              <div class="header" v-if="row.label">{{ row.label }}</div>
              <div class="data" v-for="(properties, index) in row.properties" :key="`properties-${index}`">
                {{ properties.data }}
              </div>
              <div class="data" v-for="(data, index) in row.data" :key="`data-${index}`">
                {{ data.data }}
              </div>
              <div
                class="total-row"
                v-for="(data, index) in dialInfo.groupResults[rowIndex].properties"
                :key="`totalData-${index}`"
              >
                <div v-if="data.data" class="data">{{ data.data }}</div>
              </div>
              <div
                class="total-row"
                v-for="(data, index) in dialInfo.groupResults[rowIndex].data"
                :key="`totalData-${index}`"
              >
                <div v-if="data.data" class="data">{{ data.data }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="left-table" v-if="dialInfo.levels">
        <div class="left-table-container">
          <div v-for="(row, rowIndex) in dialInfo.levels" :key="`row-${rowIndex}`">
            <div v-if="row.label" class="row">
              <div class="header" v-if="row.label">{{ row.label }}</div>
              <div class="data" v-for="(properties, index) in row.properties" :key="`properties-${index}`">
                {{ properties.data }}
              </div>
              <div class="data" v-for="(data, index) in row.data" :key="`data-${index}`">
                {{ data.data }}
              </div>
              <div
                class="total-row"
                v-for="(data, index) in dialInfo.levelResults[rowIndex].data"
                :key="`totalData-${index}`"
              >
                <div v-if="data.data" class="data">{{ data.data }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="left-table" v-if="dialInfo.totals">
        <div class="left-table-container">
          <div v-for="(row, rowIndex) in dialInfo.totals" :key="`row-${rowIndex}`">
            <div v-if="row.label" class="row">
              <div class="header" v-if="row.label">{{ row.label }}</div>
              <div class="data" v-for="(properties, index) in row.properties" :key="`properties-${index}`">
                {{ properties.data }}
              </div>
              <div class="data" v-for="(data, index) in row.data" :key="`data-${index}`">
                {{ data.data }}
              </div>
              <div
                class="data total-row"
                v-for="(data, index) in dialInfo.totalResults[rowIndex].data"
                :key="`totalData-${index}`"
              >
                {{ data.data }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p v-if="dialInfo.detailsSectionTitle" class="section-title">{{ dialInfo.detailsSectionTitle }}</p>
    <div v-if="dialInfo.detailsSectionTitle" class="row-2 flex-row">
      <div class="left-table" v-if="dialInfo.firstDetailSection">
        <div class="left-table-container">
          <div v-for="(row, rowIndex) in dialInfo.firstDetailSection" :key="`row-${rowIndex}`">
            <div v-if="row.label" class="row">
              <div class="header" v-if="row.label">{{ row.label }}</div>
              <div class="data" v-for="(data, index) in row.data" :key="`data-${index}`">
                {{ data.data }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="left-table" v-if="dialInfo.levelDetailSection">
        <div class="left-table-container">
          <div v-for="(row, rowIndex) in dialInfo.levelDetailSection" :key="`row-${rowIndex}`">
            <div v-if="row.label" class="row">
              <div class="header" v-if="row.label">{{ row.label }}</div>
              <div class="data" v-for="(data, index) in row.data" :key="`data-${index}`">
                {{ data.data }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="left-table" v-if="dialInfo.lastDetailSection">
        <div class="left-table-container">
          <div v-for="(row, rowIndex) in dialInfo.lastDetailSection" :key="`row-${rowIndex}`">
            <div v-if="row.label" class="row">
              <div class="header" v-if="row.label">{{ row.label }}</div>
              <div class="data" v-for="(data, index) in row.data" :key="`data-${index}`">
                {{ data.data }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MLT',
  components: {},
  props: {
    dialInfo: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.left-table {
  margin-right: 10px;
}
.section-title {
  font-size: 20px;
  font-weight: bold;
  line-height: 26px;
  color: $primary;
  text-transform: uppercase;
  text-align: left;
  margin: 40px 0px;
}
</style>
